import { useMutation, useQueryClient } from "@tanstack/react-query";
import { assignParcours } from "../api/membersApi";
import { queryKeys } from "../lib/queryKeys";

export interface AssignParcoursArgs {
  memberId: string;
  parcoursId: string;
}

export function useAssignParcours() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ memberId, parcoursId }: AssignParcoursArgs) => assignParcours(memberId, parcoursId),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: queryKeys.members.all });
    },
  });
}
